module.exports = __webpack_public_path__ + "static/media/security.a1fa8f2f.svg";